(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('WebDocumentHelper', [
        '$window',
        WebDocumentHelper
    ]);

    function WebDocumentHelper(
        $window
    ) {
        return {
            openDocumentInSeparateTab: openDocumentInSeparateTab                
        };

        function openDocumentInSeparateTab(documentGetStaticUrlPromise) {
            //Need to open the window directly from click handler to avoid popup blockers.
            //Go ahead and open tab in IE even though it probably won't load,
            //because other browsers might behave the same way in certain configurations.

            var newWindow = $window.open('');
            newWindow.document.write('loading...');
            newWindow.document.close();
            
            documentGetStaticUrlPromise.then(function(url) {
                // IE will leave the window/tab open, so clear the loading message.
                newWindow.document.write('');
                newWindow.document.close();
                newWindow.location.href = url;
            }).catch(function() {
                newWindow.close();
            });
        }
    } 
})(angular);
